import { ActionTree } from 'vuex';
import PnpToolState from './types';
import { PnpMutationsEnum } from './mutations';
import PnpItem from '../../../models/PnpItem';

export const pnpToolActions: ActionTree<PnpToolState, never> = {
  // Tool Visibility
  initializeState({ commit }, initialValues: Map<string, boolean>): void {
    commit(PnpMutationsEnum.initializeState, initialValues);
  },
  toggleTool({ commit }, toolType: string): void {
    commit(PnpMutationsEnum.toggleTool, toolType);
  },
  setHidden({ commit }, toolType: string): void {
    commit(PnpMutationsEnum.setHidden, toolType);
  },

  // Buttons
  setPnpItemArray({ commit }, newPnpArray: Array<PnpItem>): void {
    commit(PnpMutationsEnum.setPnpItemArray, newPnpArray);
  },
};
